import type { RouteRecordRaw } from 'vue-router';
import DomesticViolenceCard from './DomesticViolenceCard.vue';
import { RouteNames } from '@/router/routeNames';

const route: RouteRecordRaw = {
  name: RouteNames.DOMESTIC_VIOLENCE,
  path: 'domesticviolence',
  props: true,
  component: DomesticViolenceCard,
  meta: {
    pageTitle: 'Landing.DomesticViolence',
  },
};

export default route;
